import { gql } from '@apollo/client';

const UPLOAD_FILE = gql`
  mutation UploadS3file($key: String, $bucket: String!, $contentType: String, $region: String) {
    UploadS3file(key: $key, bucket: $bucket, contentType: $contentType, region: $region) {
      fileName
      signedURL
      uuid
    }
  }
`;

export default UPLOAD_FILE;
